<div class="border-round p-3 flex align-items-center" [ngClass]="{'bg-red-200': type === 'danger', 'bg-green-300': type === 'success'}">

  <i *ngIf="type==='danger'" class="pi pi-exclamation-circle mr-2" style="font-size: 2rem"></i>
  <ng-content></ng-content>

</div>
